module.exports = __webpack_public_path__ + "img/w3_circle_list_dark.9ae6d84f.png";